import classNames from "classnames";
import { setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import styles from "./Badge.module.less";

export type BadgeProps = {
	amount: number;
	isActive?: boolean;
	trackingId: string;
};

export const Badge = (props: BadgeProps): ReactElement => {
	const {
		amount,
		isActive = false,
		trackingId
	} = props;

	return (
		<div
			{...setTrackingId(trackingId)}
			className={classNames(
				styles.root,
				{
					[styles.root_active]: isActive
				}
			)}
		>
			{amount > 99 ? "99+" : amount}
		</div>
	);
};
Badge.displayName = "Badge";
